import { DEFAULT_LANGUAGE } from './constants/languages';
let currentLanguage = DEFAULT_LANGUAGE;
/**
 * Sets the language every package resolves its labels against. Call once at
 * application startup and again on every language switch.
 *
 * Labels are read at render time, so components already on screen keep their old
 * strings until they re-render — applications remount the routed tree on a
 * language switch, which is what makes that safe.
 */
export function setLanguage(language) {
    currentLanguage = language;
}
export function getLanguage() {
    return currentLanguage;
}
